import * as React from 'react'

function SvgAsset3(props) {
  return (
    <svg viewBox="0 0 181.49 181.49" {...props}>
      <g data-name="Layer 2">
        <path
          className="Asset_3_svg__cls-1"
          d="M136.12 0L90.75 22.69l45.37 22.68 45.37-22.68zM45.37 0L0 22.69l45.37 22.68 45.38-22.68zm90.75 68.06l45.37 22.69V45.37zm-90.75 0l45.38 22.69 45.37-22.69-45.37-22.69zM0 90.75l45.37-22.69L0 45.37zm90.75 22.68l45.37 22.69 45.37-22.69-45.37-22.68zm-90.75 0l45.37 22.69 45.38-22.69-45.38-22.68zm136.12 45.38l45.37 22.68v-45.37zm-90.75 0l45.38 22.68 45.37-22.68-45.37-22.69zM0 181.49l45.37-22.68L0 136.12z"
          data-name="Layer 1"
        />
      </g>
    </svg>
  )
}

export default SvgAsset3
